 'use client';

import { useEffect, useState } from 'react';
import useStore from '.';
import { usePathname } from 'next/navigation';
import { CompanyDetails } from '_services/common.service';
import { Category } from '@/components/catelog/category-card';
import OnlineHoldComponent from '@/components/pages/onlinehold';
import FooterNavbar from '@/components/footer-navbar';
import useDuplicateTabDetection from '../hooks/useDuplicateTabDetection';
import styles from '../styles/duplicate-modal.module.scss';
import { Modal, Button } from 'react-bootstrap';

interface ClientInitializerProps {
  updateCompanyDetails: CompanyDetails | null;
  categories?: Category[] | [];
  deals?: Category[] | [];
  children?: React.ReactNode;
  isLocationOpen?: boolean;
}


export default function ClientInitializer({ updateCompanyDetails, categories, deals, children, isLocationOpen }: ClientInitializerProps) {
  const pathname = usePathname();
  const isOnlineOrderingHold = (['/trackorder', '/revieworder'].some(path => pathname.includes(path)) === false && isLocationOpen === false);
  // console.log(pathname);
  // console.log(isOnlineOrderingHold);
  
  
  //trackorder, revieworder

  const { setCompanyDetails, setCategories } = useStore();

  useEffect(() => {
    // console.log("Company Details:", companyDetails);

    if (updateCompanyDetails) {
      setCompanyDetails(updateCompanyDetails);
    }
  }, [updateCompanyDetails, setCompanyDetails]);

  useEffect(() => {
    // console.log("Categories:", categories);

    if (categories && categories.length > 0) {
      setCategories(categories);
    }
  }, [categories, setCategories]);

  useEffect(() => {
    // console.log("Deals:", deals);
    if (deals && deals.length > 0) {
      const { setDeals } = useStore.getState();
      setDeals(deals);
    }
  }, [deals]);

  // console.log("ClientInitializer Rendered with Company Details:", companyDetails);
  const [duplicateDetected, setDuplicateDetected] = useState(false);

  useDuplicateTabDetection(() => {
    setDuplicateDetected(true);
  });

  return <>
    {isOnlineOrderingHold ? <OnlineHoldComponent /> : 
    <>
    {children}
    <FooterNavbar />
    </>}

    <Modal
      show={duplicateDetected}
      onHide={() => setDuplicateDetected(false)}
      centered
      dialogClassName={styles.dupDialog}
      contentClassName={styles.dupContent}
      backdropClassName={styles.dupBackdrop}
      backdrop="static"
      keyboard={false}
      style={{ zIndex: 999999 }}
    >
      <Modal.Header className={styles.dupHeader}>
        <Modal.Title className={styles.dupTitle}>Duplicate Tab Detected</Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles.dupBody}>
        <p>Hey there! Looks like this site is open in another tab. Close the other tabs and refresh this page to continue smoothly.</p>
      </Modal.Body>

      <Modal.Footer className={styles.dupFooter}>
        <Button className={styles.closeBtn} onClick={() => window.location.reload()}>Refresh Page</Button>
      </Modal.Footer>
    </Modal>
  </>; // this just initializes state
}